<template>
  <div class="flex flex-col bg-beige1 p-4 md:items-center md:py-6">
    <div class="flex w-full items-center gap-2 md:w-[640px] md:p-0">
      <button aria-label="search button" class="flex h-[46px] min-w-0 flex-1 items-center border-[0.5px] border-gray7 bg-white px-4" data-testid="search-button" @click="() => open()">
        <span class="w-[18px]"> <AtomsSearchIcon /></span>
        <span class="ml-3 truncate text-xs tracking-wider">
          <template v-if="selectedSearchConditionsLabel.length > 0">
            <span class="leading-5 text-gold1">{{ selectedSearchConditionsLabel }}</span>
          </template>
          <template v-else>
            <span class="text-gray2">Search</span>
          </template>
        </span>
      </button>
      <!-- マップビューの list/map トグル等（モバイルのみ。検索バーと同一行に配置: Figma 準拠） -->
      <slot name="action" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useKeywordSearchModal } from '@/wabunka-src/features/Search/composables/general/useKeywordSearchModal';

export interface SelectedSearchConditions {
  Destinations: string[];
  Themes: string[];
  Preferences: string[];
  TimeOfDay: string[];
}

interface Props {
  selectedSearchConditions: SelectedSearchConditions;
}

const props = withDefaults(defineProps<Props>(), {});
const { open } = useKeywordSearchModal();

const selectedSearchConditionsLabel = computed<string>(() => {
  const destinationsLabel = props.selectedSearchConditions.Destinations.join(', ');
  const themesLabel = props.selectedSearchConditions.Themes.join(', ');
  const preferencesLabel = props.selectedSearchConditions.Preferences.join(', ');
  const timeOfDayLabel = props.selectedSearchConditions.TimeOfDay.join(', ');

  // 空でないラベルをフィルタリングし、' / ' で結合
  return [destinationsLabel, themesLabel, preferencesLabel, timeOfDayLabel].filter(Boolean).join(' / ');
});
</script>
